<div class="push-notifications-container settings-page">

  <div class="settings-page__content">
    <p-tabs [value]="activeTab()" (valueChange)="onTabChange('' + $event)">
      <p-tablist>
        <p-tab value="overview">{{ 'SETTINGS.PUSH_NOTIFICATIONS.TAB_OVERVIEW' | translate }}</p-tab>
        <p-tab value="connection-test">
          {{ 'SETTINGS.PUSH_NOTIFICATIONS.TAB_CONNECTION_TEST' | translate }}
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="overview">
          <div class="overview-tab">
            @if (overviewInitialLoadFailed() && overviewError(); as error) {
              <tf-settings-load-error
                [title]="error"
                [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
                [details]="overviewErrorDetails()"
                [dense]="true"
                (retry)="reloadOverview()" />
            } @else if (isOverviewLoading()) {
              <div class="loading-container">
                <p-progressSpinner strokeWidth="4" />
              </div>
            } @else {
              <tf-settings-inline-message
                [message]="overviewError()"
                messageId="push-overview-load-error"
                (dismissed)="clearOverviewError()" />

              <div class="stats-grid">
                <div class="stat-card">
                  <span class="stat-value">{{ totalDevices() }}</span>
                  <span class="stat-label">
                    {{ 'SETTINGS.PUSH_NOTIFICATIONS.TOTAL_DEVICES' | translate }}
                  </span>
                </div>
                <div class="stat-card">
                  <span class="stat-value">{{ totalUsersWithDevices() }}</span>
                  <span class="stat-label">
                    {{ 'SETTINGS.PUSH_NOTIFICATIONS.TOTAL_USERS' | translate }}
                  </span>
                </div>
              </div>

              @if (hasCustomConfig()) {
                <p-message severity="info">
                  {{ 'SETTINGS.PUSH_NOTIFICATIONS.CUSTOM_CONFIG_INFO' | translate }}
                </p-message>
              }

              @if (totalDevices() === 0) {
                <p-message severity="secondary">
                  {{ 'SETTINGS.PUSH_NOTIFICATIONS.NO_DEVICES_MESSAGE' | translate }}
                </p-message>
              }
            }
          </div>
        </p-tabpanel>

        <p-tabpanel value="connection-test">
          <div class="connection-test-tab">
            <tf-settings-list-header
              [searchQuery]="searchQuery()"
              [searchPlaceholder]="'SETTINGS.PUSH_NOTIFICATIONS.SEARCH_PLACEHOLDER' | translate"
              [loading]="isDevicesLoading()"
              [refreshTooltip]="'SETTINGS.PUSH_NOTIFICATIONS.RELOAD' | translate"
              (searchChange)="onSearchChange($event)"
              (refresh)="reloadDevices()">
              <tf-settings-push-device-filters
                headerActions
                [platformType]="platformTypeFilter()"
                [hasActiveFilters]="hasActiveFilters()"
                [isLoading]="isDevicesLoading()"
                (filterApplied)="onFilterApplied($event)"
                (filterCleared)="onFilterCleared()" />
            </tf-settings-list-header>

            @if (devicesInitialLoadFailed() && devicesError(); as error) {
              <tf-settings-load-error
                [title]="error"
                [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
                [details]="devicesErrorDetails()"
                [dense]="true"
                (retry)="reloadDevices()" />
            } @else {
              <tf-settings-inline-message
                [message]="devicesError()"
                messageId="push-devices-load-error"
                (dismissed)="clearDevicesError()" />

              <tf-data-table
                [columns]="columns"
                [value]="devices()"
                [loading]="isDevicesLoading()"
                [paginator]="true"
                [rows]="pageSize()"
                [totalRecords]="totalRecords()"
                [lazy]="true"
                emptyMessageKey="SETTINGS.PUSH_NOTIFICATIONS.NO_DEVICES_MESSAGE"
                styleClass="p-datatable-sm"
                (paged)="onPageChange($event)">
                <ng-template tfColumnDef="user" let-device>
                  <span>{{ device.lastname }}, {{ device.firstname }}</span>
                </ng-template>
                <ng-template tfColumnDef="platformType" let-device>
                  <span class="platform-cell">
                    <i [class]="getPlatformIcon(device.platformType)" aria-hidden="true"></i>
                    <span>{{ getPlatformLabelKey(device.platformType) | translate }}</span>
                  </span>
                </ng-template>
                <ng-template tfColumnDef="tokenPrefix" let-device>
                  <span class="token-prefix">{{ device.tokenPrefix }}…</span>
                </ng-template>
                <ng-template tfColumnDef="_actions" let-device>
                  <p-button
                    icon="pi pi-send"
                    severity="secondary"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    [attr.aria-label]="
                      ('SETTINGS.PUSH_NOTIFICATIONS.SEND_TEST' | translate) +
                      ' — ' +
                      device.lastname +
                      ', ' +
                      device.firstname
                    "
                    [pTooltip]="'SETTINGS.PUSH_NOTIFICATIONS.SEND_TEST' | translate"
                    tooltipPosition="top"
                    (onClick)="openTestDialog(device)" />
                </ng-template>
              </tf-data-table>
            }
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <tf-settings-test-push-dialog
    [visible]="isTestDialogVisible()"
    [device]="testingDevice()"
    [logEntries]="testLogEntries()"
    [testInProgress]="testInProgress()"
    (visibleChange)="onTestDialogVisibleChange($event)"
    (send)="onTestDialogSend()" />
</div>
